import { render, staticRenderFns } from "./AccountSettingButton.vue?vue&type=template&id=63ef1b25&scoped=true&"
import script from "./AccountSettingButton.vue?vue&type=script&lang=js&"
export * from "./AccountSettingButton.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingButton.vue?vue&type=style&index=0&id=63ef1b25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ef1b25",
  null
  
)

export default component.exports